import { map } from 'rxjs/operators';
import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import { convertNestedStringToBoolean } from 'Angular/utils/state-utils';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/ajax.service";
import * as i2 from "Angular/services/core/urls.service";
export class SavedChartService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getErrorMessage(error) {
        let errorMessage;
        const unknownErrorMessage = 'An unknown error occurred, please try again.';
        switch (error.status) {
            case 400:
                errorMessage = error.error.error_message ?? unknownErrorMessage;
                break;
            case 403:
                errorMessage = error.error.error_message ?? unknownErrorMessage;
                break;
            case 404:
                errorMessage = 'Saved chart not found, please try again.';
                break;
            case 409:
                errorMessage = 'Cannot save with duplicate name, please try again.';
                break;
            default:
                errorMessage = unknownErrorMessage;
                break;
        }
        return errorMessage;
    }
    getItems(chartType, includeLegacy) {
        const urlParams = { chartType };
        const getParams = { includeLegacy };
        return this.ajaxService
            .getDataObserveBody(this.urlsService.getUrl(this.urlsService.CHARTS.CHART_VIEW_COLLECTION, urlParams), getParams)
            .pipe(map((response) => {
            convertNestedStringToBoolean(response);
            return response;
        }));
    }
    deleteItem(chartId, chartType) {
        const urlParams = {
            chartType,
            id: chartId,
        };
        const deleteUrl = this.urlsService.getUrl(this.urlsService.CHARTS.CHART_VIEW, urlParams);
        return this.ajaxService.deleteDataObserveBody(deleteUrl);
    }
    updateItem(chartId, putParams, chartType) {
        const urlParams = {
            chartType,
            id: chartId,
        };
        const putUrl = this.urlsService.getUrl(this.urlsService.CHARTS.CHART_VIEW, urlParams);
        return this.ajaxService.putDataObserveBody(putUrl, putParams);
    }
    createItem(postParams, chartType) {
        const urlParams = { chartType };
        const postUrl = this.urlsService.getUrl(this.urlsService.CHARTS.CHART_VIEW_COLLECTION, urlParams);
        return this.ajaxService.postFormEncodedDataObserveBody(postUrl, postParams).pipe(map((response) => {
            convertNestedStringToBoolean(response);
            return response;
        }));
    }
}
SavedChartService.ɵfac = function SavedChartService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SavedChartService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
SavedChartService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SavedChartService, factory: SavedChartService.ɵfac, providedIn: 'root' });
